import { PlayIcon } from '@ui/kit';
import { wrapperCls, durationCls, currentDurationCls, totalDurationCls, playButtonCls, metaCls, metaTitleCls, metaDescriptionCls, svgCls } from './audio-component.scrambled.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Scrambled() {
  return /*#__PURE__*/jsxs("div", {
    className: wrapperCls,
    children: [/*#__PURE__*/jsxs("div", {
      className: durationCls,
      children: [/*#__PURE__*/jsx("span", {
        className: currentDurationCls,
        children: "00:00"
      }), /*#__PURE__*/jsx("span", {
        className: totalDurationCls,
        children: "00:00"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: playButtonCls,
      children: /*#__PURE__*/jsx(PlayIcon, {
        height: 12,
        fill: "#383838",
        stroke: "none"
      })
    }), /*#__PURE__*/jsxs("div", {
      className: metaCls,
      children: [/*#__PURE__*/jsx("div", {
        className: metaTitleCls,
        children: "Lydklip"
      }), /*#__PURE__*/jsx("div", {
        className: metaDescriptionCls,
        children: "Log p\xE5 for at h\xF8re lydklippet"
      })]
    }), /*#__PURE__*/jsxs("svg", {
      className: svgCls,
      version: "1.1",
      viewBox: "0 0 28.1 38.8",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("path", {
        d: "M7,13.5c0.3,0,0.5-0.2,0.5-0.5v-1.7C7.8,11.2,8,10.9,8,10.5c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.4,0.2,0.7,0.5,0.8V13C6.5,13.3,6.7,13.5,7,13.5z M7,10.5C7,10.5,7,10.5,7,10.5C7,10.5,7,10.5,7,10.5l-0.5,0L7,10.5z"
      }), /*#__PURE__*/jsx("path", {
        d: "M13,8v4.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C14,7.2,13.8,7,13.5,7H12V5c0-2.8-2.2-5-5-5S2,2.2,2,5v2H0.5C0.2,7,0,7.2,0,7.5v10C0,17.8,0.2,18,0.5,18h1C1.8,18,2,17.8,2,17.5S1.8,17,1.5,17H1V8H13z M3,5c0-2.2,1.8-4,4-4s4,1.8,4,4v2H3V5z"
      }), /*#__PURE__*/jsx("path", {
        d: "M27.5,14.7h-23c-0.3,0-0.6,0.3-0.6,0.6v23c0,0.3,0.3,0.6,0.6,0.6h23c0.3,0,0.6-0.3,0.6-0.6v-23C28.1,14.9,27.8,14.7,27.5,14.7z M26.9,37.7H5.1V15.8h21.9V37.7z"
      }), /*#__PURE__*/jsx("polygon", {
        points: "9.4,24.5 9.4,29.3 12.4,29.3 16.7,32.4 16.7,21.3 12.4,24.5"
      }), /*#__PURE__*/jsx("path", {
        d: "M20.4,22.2l-0.9,0.9c1.1,1,1.7,2.4,1.7,3.9c0,1.5-0.6,2.9-1.7,3.9l0.9,0.9c1.3-1.2,2.1-2.9,2.1-4.7S21.7,23.5,20.4,22.2z"
      }), /*#__PURE__*/jsx("path", {
        d: "M18.6,23.9l-0.9,0.9c0.6,0.6,0.9,1.4,0.9,2.2c0,0.9-0.4,1.6-0.9,2.2l0.9,0.9c0.8-0.8,1.4-1.9,1.4-3.1C20,25.8,19.5,24.7,18.6,23.9z"
      })]
    })]
  });
}

export { Scrambled };
//# sourceMappingURL=audio-component.scrambled.js.map
